import { useState } from "react";

const fmt = (iso) =>
  new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
const td = "px-4 py-4 text-sm align-top";
const dash = <span className="text-[#9A97B5]">—</span>;

export default function LeadRow({ lead, onUpdate }) {
  const [notes, setNotes] = useState(lead.notes || "");
  const [saving, setSaving] = useState(false);

  const saveNotes = async () => {
    if (notes === (lead.notes || "")) return;
    setSaving(true);
    await onUpdate(lead.id, { notes });
    setSaving(false);
  };

  return (
    <tr data-testid="lead-row" className={`border-b border-[#E3E3F0]/70 last:border-0 transition-colors ${lead.contacted ? "bg-[#4B2A9E]/[0.04]" : "hover:bg-[#FFFFFF]"}`}>
      <td className={`${td} text-center`}>
        <input
          data-testid="lead-contacted-checkbox"
          type="checkbox"
          checked={!!lead.contacted}
          onChange={(e) => onUpdate(lead.id, { contacted: e.target.checked })}
          className="w-4 h-4 accent-[#4B2A9E] cursor-pointer"
          title="Contacted"
        />
      </td>
      <td className={`${td} text-[#4A4A66] whitespace-nowrap`}>{fmt(lead.created_at)}</td>
      <td className={`${td} font-semibold text-[#0B0B12]`}>{lead.name}</td>
      <td className={td}><a href={`mailto:${lead.email}`} className="text-[#1B2FD8] hover:underline">{lead.email}</a></td>
      <td className={`${td} whitespace-nowrap`}>{lead.phone}</td>
      <td className={td}>{lead.instagram || dash}</td>
      <td className={td}>{lead.referrer || dash}</td>
      <td className={`${td} max-w-[180px] text-[#4A4A66]`}>{lead.message || dash}</td>
      <td className={td}>
        <span className={`rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider ${lead.consent ? "bg-[#4B2A9E]/10 text-[#4B2A9E]" : "bg-[#E3E3F0] text-[#4A4A66]"}`}>
          {lead.consent ? "Yes" : "No"}
        </span>
      </td>
      <td className={`${td} min-w-[200px]`}>
        <textarea
          data-testid="lead-notes-input"
          rows={2}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          onBlur={saveNotes}
          placeholder="Add a note…"
          className={`w-full rounded-lg bg-[#FFFFFF] border border-[#E3E3F0] px-3 py-2 text-sm focus:outline-none focus:border-[#1B2FD8] focus:bg-white transition-colors resize-none ${saving ? "opacity-60" : ""}`}
        />
      </td>
    </tr>
  );
}
